import * as angular from 'angular';
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import nvSharedModelsModule from '../nv.shared.models.module';

angular
  .module(nvSharedModelsModule)
  .factory('GapPlan', function(NvBaseModel, UtilitiesService: UtilitiesService, $http, PublicConfig, DateHelpers) {
    const PERMISSIONING_MODEL_NAME = 'GAP_PLAN';
    const relationToUserPath = 'createdBy.userId';

    let GapPlan = NvBaseModel(
      // eslint-disable-line new-cap
      '/v1/gapPlans/:id',
      { id: '@_id' },
      null,
      null,
      PERMISSIONING_MODEL_NAME,
      relationToUserPath,
    );

    /**
     * Update a single gap plan
     * @param id {string}
     * @param path {string} dot notation path to change
     * @param newValue {any} new value to set at path
     * @returns {HttpPromise}
     */
    GapPlan.singleUpdate = (id, path, newValue) => {
      const patch = UtilitiesService.setFieldByPath({}, path, newValue);
      return $http.patch(PublicConfig.NV_API_ORIGIN + '/v1/gapPlans/' + id, patch);
    };

    return GapPlan;
  });
